import { StateSchema } from 'app/config/storeConfig/types';

export const getEmail = (state: StateSchema): Nullable<string> => state.emailHistoryModal.email;
